import React, { useEffect, useState } from "react";
import { AppBar, Toolbar, IconButton, Box, Typography, Button } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import sizeConfigs from "../../../configs/sizeConfigs";
import colorConfigs from "../../../configs/colorConfigs";
import { PATH_NAME } from "../../../configs/pathName";
import { profileStyles } from "../../../styles/ProtectedPage/profile";
import { useNavigate } from "react-router-dom";
import { typo } from "../../../assets/fonts/font";

interface TopBarProps {
  onMenuClick: () => void;
}

const TopBar: React.FC<TopBarProps> = ({ onMenuClick }) => {
  const [, setUserInfo] = useState<any>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const storedUserInfo = localStorage.getItem('userInfo');
    if (storedUserInfo) {
      setUserInfo(JSON.parse(storedUserInfo) || '');
    }
  }, []);

  const handleAvatarClick = () => {
    navigate(PATH_NAME.PROFILE);
  };

  return (
    <AppBar
      position="absolute"
      sx={{
        width: { sm: `calc(100% - ${sizeConfigs.sidebar.width})` },
        ml: { sm: sizeConfigs.sidebar.width },
        boxShadow: "unset",
        backgroundColor: colorConfigs.secondary,
        color: colorConfigs.tertiary,
        borderBottom: `1px solid ${colorConfigs.tertiary}`,
      }}
    >
      <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="menu"
            onClick={onMenuClick}
            sx={{ mr: 2, display: { sm: "none" } }}
          >
            <MenuIcon />
          </IconButton>
        </div>
        <Box sx={{ display: "flex", alignItems: "center", flexGrow: 1, justifyContent: "flex-end" }}>
          <Button sx={{ p: 0 }} onClick={handleAvatarClick}>
            <Typography sx={{ ...typo.button,...profileStyles, fontSize: "12px", ml: 1 }}>
              My Account
            </Typography>
          </Button>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default TopBar;
